import { TreeMixin, itemTypeLoadMore, itemTypeDefault } from './mixin';
import ApiService from '../../../../services/apiService';
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import clone from 'lodash/clone';
import get from 'lodash/get';
export default {
  name: 'CoreDtwinTreeSelection',
  mixins: [TreeMixin],
  props: {
    searchEnabled: {
      type: Boolean,
      required: false,
      default: () => true
    },
    loadStates: {
      type: Boolean,
      required: false,
      default: () => false
    },
    selectedTwins: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      statesForTwins: {}
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions'])
  },
  watch: {
    selectedTwins() {
      this.cleanTreeSelection();
    }
  },
  created() {
    this.loadDescendents = false;
    this.itemTypeLoadMore = itemTypeLoadMore;
  },
  mounted() {
    this.initTree();
  },
  methods: {
    initTree() {
      this.twinTreeItems = [];
      this.twinItemMapping = {};
      this.twinItemMapping[this.parentId] = {};

      // an active node is specified, so make sure to load the tree-structure to accomodate this node
      // might not be on root-level, so there is special handling required to have it displayed right away
      if (this.activeDtwinId) {
        this.fetchPartialTree(this.activeDtwinId);
      } else {
        this.fetchChildren({
          id: this.parentId
        }, true);
      }
    },
    fetchChildren(item, initially = false) {
      return this.fetchChildrenDefault(item.id, 0, initially);
    },
    cleanTreeSelection() {
      const iterateChildren = children => {
        children.forEach(child => {
          if (child.id && typeof child.id !== 'string') {
            if (this.selectedTwins.findIndex(t => t.id === child.id) < 0) {
              child.selected = false;
            }
          } else {
            if (child.children) {
              iterateChildren(child.children);
            }
          }
        });
      };
      iterateChildren(this.twinTreeItems);
      // force a refresh
      this.twinTreeItems = clone(this.twinTreeItems);
    },
    processTreeItems(items) {
      // fetch all states for each twin (no UI-output yet, tho)
      return this.processTreeItemsStates(items).then(() => {
        return this.processTreeItemsDefault(items);
      });
    },
    itemType(item) {
      const itemId = get(item, 'id');
      if (typeof itemId === 'string') {
        if (itemId.startsWith(itemTypeLoadMore)) {
          return itemTypeLoadMore;
        }
      }
      return itemTypeDefault;
    },
    getTwinTreeIcon(dtwin) {
      // special case for the "Load More" tree item
      if (this.itemType(dtwin) === itemTypeLoadMore) {
        return this.getTwinTreeIconDefault(dtwin);
      }
      // return this.getTwinTreeIconStates(dtwin);
      return this.getTwinTreeIconDefault(dtwin);
    },
    // --------
    // STATES
    // --------

    fetchBindingsForTwinIds(twinIds) {
      const twinIdsToBeFetched = twinIds.filter(twinId => {
        return !this.statesForTwins[twinId];
      });
      if (twinIdsToBeFetched.length > 0) {
        twinIdsToBeFetched.forEach(id => {
          if (!this.statesForTwins[id]) {
            this.statesForTwins[id] = [];
          }
        });
        return ApiService.digitalTwinsFetchStates(this, twinIdsToBeFetched, ['bare']).then(states => {
          states.forEach(state => {
            this.statesForTwins[state.dtwinId].push(state);
          });
          this.twinTreeItems = clone(this.twinTreeItems);
        });
      }
      return Promise.resolve();
    },
    processTreeItemsStates(items) {
      if (!this.loadStates) {
        return Promise.resolve();
      }
      let fetchStatesForTwinIds = [];
      items.forEach(item => {
        if (item.id && typeof item.id !== 'string') {
          this.twinItemMapping[item.id] = item;
          fetchStatesForTwinIds.push(item.id);
        }
      });
      return this.fetchBindingsForTwinIds(fetchStatesForTwinIds);
    },
    twinSelectionToggled(item) {
      let cleanItem = cloneDeep(item);
      if (this.twinIsSelected(cleanItem)) {
        // remove from list
        this.$emit('deselectedTwin', cleanItem);
      } else {
        // add to list
        this.$emit('selectedTwin', cleanItem);
      }
    },
    twinIsSelected(item) {
      return this.selectedTwins.findIndex(selectedTwin => selectedTwin.id === item.id) >= 0;
    }
  }
};